import { useQuery } from '@tanstack/react-query'

import { ApiUrlPath, X_AUTH_TOKEN, IQuestion, AppMsg } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

type TError = {
  msg: AppMsg
}

export const useGetQuestionProposal = (
  getParams: () => { category: string; subject: string }
) => {
  const getQuestionProposal = async () => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const { category, subject } = getParams()

    let url = `${ApiUrlPath.GetQuestionProposal}?category=${category}`
    if (subject) {
      url += `&subject=${subject}`
    }

    const res = await fetch(
      url,
      {
        headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
        signal: abortController.signal,
      },
      0
    )

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as IQuestion
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useQuery<IQuestion, TError>(
    [ApiUrlPath.GetQuestionProposal],
    getQuestionProposal,
    {
      enabled: false,
      cacheTime: 0,
      keepPreviousData: true,
    }
  )
}
